import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statServiceCounterModule: LocaleModule = {
  name: "statServiceCounter",
  messages: { en: en, it: it },
};
